export default {
  SINGLE_CHOICE: 1,
  ARRANGE_SENTENCES: 2,
  CHARACTER: 1,
  NARRATOR: 2,
  SHOW_LEFT: 1,
  SHOW_RIGHT: 2
}
